import { RouteLocationNormalized } from "vue-router";
import { userSessionStore } from "@/store/user_session";
import { WSClient } from "@/ems/WSClient";
import { LoggedUser } from "@/types/user";

const loginGard = async (to: RouteLocationNormalized) => {
    if (to.name == "login" || to.name == "signup" || to.name == "signupInvitedUsers") {
        console.log("No auth required, go to url");
        return true;
    }

    // Auth gard
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        const user_guard = await normal_user_routing(to);
        if (user_guard) return user_guard;
    }

    // Admin guard
    else if (to.matched.some((record) => record.meta.requiresAdmin)) {
        const admin_guard = await admin_routing(to);
        if (admin_guard) return admin_guard;
    }
    return true;
};

const normal_user_routing = async (to: RouteLocationNormalized) => {
    const user_session = userSessionStore();
    try {
        const destination = {
            name: to.name,
            params: to.params,
            query: to.query,
        };
        sessionStorage.setItem("afterlogin", JSON.stringify(destination));
    } catch (e) {
        console.log(e);
        console.log("Error sezialisation error");
        console.log(to);
    }
    return await user_session.session_check(new WSClient(), to.name == "root")
        .then((logged_user) => {
            return handle_session_check_res(logged_user, to);
        })
        .catch((err: unknown) => {
            console.error("session_check error", err);
        });
};

const admin_routing = async (to: RouteLocationNormalized) => {
    const user_session = userSessionStore();
    const logged_user = await user_session.session_check(new WSClient(), false);

    try {
        if (logged_user?.UserId) {
            if (logged_user.is_admin) {
                return true;
            }
            console.log("Not admin redirect to list");
            return { path: "/organization" };
        } else {
            console.log("Not connecto to admin, got to login");
            return {
                name: "login",
                params: { redir: to.fullPath },
            };
        }
    } catch (error) {
        console.error("Error in admin nav gard:");
        console.error(error);
        return false;
    }
};

const gotToRoot = async () => {
    (new WSClient()).queryWs<{ home_name: string }>("GET", "user_onboardstatus", null)
        .then((res2: any) => {
            return { name: res2.home_name || "series_list" };
        })
        .catch(() => {
            return { name: "series_list" };
        });
};

const check_serie = async (to: RouteLocationNormalized, logged_user: any) => {
    if (!to.params.series_id) {
        return false;
    }

    return await (new WSClient()).queryWs<{ home_name: string }>("GET", "serie_serie", {
        serie_id: to.params.series_id,
        with_plan: true,
    }).then((res2: any) => {
        return handle_serie_result(res2, to, logged_user);
    });
};

const handle_serie_result = (res2: any, to: RouteLocationNormalized, logged_user: any) => {
    console.log(res2);
    const serie = res2?.serie;
    console.log(serie);
    console.log(logged_user.UserId);

    if (!serie.current_plan?.name && to.name !== "export") {
        console.log("User is unpaid");
        if (serie?.UserId != logged_user.UserId) {
            // Already going to CollabRequest - allow to prevent infinite loop
            if (to.name === "CollabRequest") {
                return true;
            }
            console.log("User is not the owner of the serie, redirect to CollabRequest, series_id:", to.params.series_id);
            return {
                name: "CollabRequest",
                params: {
                    series_id: to.params.series_id,
                },
            };
        }
        // Already going to offers - allow to prevent infinite loop
        if (to.name === "offers") {
            return true;
        }
        return {
            name: "offers",
            query: {
                serie_id: to.params.series_id,
                trial: 1,
            },
        };
    }
    return false;
};

const handle_session_check_res = async (logged_user: LoggedUser | null, to: RouteLocationNormalized) => {
    try {
        if (logged_user?.UserId) {
            if ((!logged_user || logged_user.payment_status === "unpaying") && !to.matched.some((record) => record.meta.free)) {
                return await check_serie(to, logged_user);
            }
            if (to.name == "root") {
                console.log("Connected, got to root page");
                const rootRoute = await gotToRoot();
                return rootRoute;
            } else {
                console.log("Connected, go to the url");
                return true;
            }
        } else {
            console.log("Not connected redirect to login");
            return { name: "login", query: { error: 401 } };
        }
    } catch (error) {
        console.error("Error in auth nav gard:");
        console.error(error);
    }
};

export default loginGard;
